import { ProductCategoriesLink } from "components/Navbar/types"
import { useAppSelector } from "hooks/storeHooks"
import { useEffect, useState } from "react"
import { Outlet, useLocation, useNavigate } from "react-router-dom"
import { selectUserInfo } from "store/user/userSlice"
import { Box } from "@strapi/design-system"

export const AdminUserLayout: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { groups, username } = useAppSelector(selectUserInfo)
  const [isChecking, setIsChecking] = useState(true)

  useEffect(() => {
    if (!username) navigate("/login", { replace: true })
    else if (!groups.includes("Admin")) navigate(ProductCategoriesLink.MAKEUP, { replace: true })

    setIsChecking(false)
  }, [groups, navigate, location.pathname, username])

  if (isChecking)
    return (
      <Box
        style={{
          width: "100vw",
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      />
    )

  return <Outlet />
}
